import type { ReactNode } from 'react';
import { formatKeyboardShortcut } from '../utils/keyboard-shortcut';

interface KeyboardShortcutProps {
  shortcut: string;
  className?: string;
  icon?: ReactNode;
}

export default function KeyboardShortcut({ shortcut, className = '', icon }: KeyboardShortcutProps) {
  return (
    <span
      className={`hidden md:inline-flex items-center justify-center text-[8px] leading-none text-zinc-700 ${className}`}
      title={shortcut}
    >
      {icon ?? formatKeyboardShortcut(shortcut)}
    </span>
  );
}
